export default __webpack_public_path__ + "static/media/buy_gmx_bond.67f59201.svg";